import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import PutAwayRtnIndexActions, { PutAwayRtnIndexTypes } from '../Stores/PutAwayRtnIndex/Actions';

const getAppStore = state => state.app;

export function* putAwayRtnIndexFetchPutAwayRtnIndex({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(PutAwayRtnIndexActions.putAwayRtnIndexFetchPutAwayRtnIndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `putAway/indexPutAwayRtn/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        PutAwayRtnIndexActions.putAwayRtnIndexFetchPutAwayRtnIndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayRtnIndexActions.putAwayRtnIndexFetchPutAwayRtnIndexLoading(false));
  }
}

export function* putAwayRtnIndexGoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/putAwayDetail/update/${hdrId}`));
}

export function* putAwayRtnIndexGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/PUT_AWAY/${hdrId}/PutAwayHdr`));
}

export function* putAwayRtnIndexResetPutAwaySync01({ hdrIds }) {
  try {
    yield put(PutAwayRtnIndexActions.putAwayRtnIndexWorkspaceLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      divisionId: app.curDivisionId,
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `putAway/syncProcess/RESET_PUT_AWAY_SYNC_01`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(PutAwayRtnIndexActions.putAwayRtnIndexResetPutAwaySync01Success());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayRtnIndexActions.putAwayRtnIndexWorkspaceLoading(false));
  }
}

export function* putAwayRtnIndexResetPutAwayFServ01({ hdrIds }) {
  try {
    yield put(PutAwayRtnIndexActions.putAwayRtnIndexWorkspaceLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      divisionId: app.curDivisionId,
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `putAway/fServProcess/RESET_PUT_AWAY_F_SERV_01/${app.curSiteFlowId}/${app.curDivisionId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(PutAwayRtnIndexActions.putAwayRtnIndexResetPutAwayFServ01Success());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayRtnIndexActions.putAwayRtnIndexWorkspaceLoading(false));
  }
}

export const saga = [
  takeLatest(PutAwayRtnIndexTypes.PUT_AWAY_RTN_INDEX_GO_TO_DOCUMENT, putAwayRtnIndexGoToDocument),
  takeLatest(PutAwayRtnIndexTypes.PUT_AWAY_RTN_INDEX_GO_TO_AUDIT, putAwayRtnIndexGoToAudit),
  takeLatest(
    PutAwayRtnIndexTypes.PUT_AWAY_RTN_INDEX_FETCH_PUT_AWAY_RTN_INDEX,
    putAwayRtnIndexFetchPutAwayRtnIndex
  ),

  takeLatest(
    PutAwayRtnIndexTypes.PUT_AWAY_RTN_INDEX_RESET_PUT_AWAY_SYNC01,
    putAwayRtnIndexResetPutAwaySync01
  ),
  takeLatest(
    PutAwayRtnIndexTypes.PUT_AWAY_RTN_INDEX_RESET_PUT_AWAY_F_SERV01,
    putAwayRtnIndexResetPutAwayFServ01
  )
];
